import React from 'react'
import PropTypes from 'prop-types'
import AsyncStorage from '@react-native-async-storage/async-storage'
import {View, Image, StyleSheet, Text, TextInput, TouchableOpacity, KeyboardAvoidingView, Platform} from 'react-native'
import {logins} from '../logins'
import {isPortrait} from '../orientation'

type Props = {
  login: Function,
}

/**
 * The Login component for the mobile version.
 */
export const Login = ({login}: Props) => {
  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [portrait, setPortrait] = React.useState(isPortrait())

  const resize = () => {
    setPortrait(isPortrait())
  }

  const styles = StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: portrait ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      backgroundColor: 'white'
    },
    image: {
      height: portrait ? 500 : 300,
      width: portrait ? 400 : 240,
    },
    text: {
      fontSize: 30,
      margin: 20,
      fontWeight: '600',
    },
    textInput: {
      padding: 10,
      borderColor: '#a1a1a1',
      borderWidth: 1,
      borderRadius: 100,
      textAlign: 'center',
      width: 300,
      margin: 10,
    },
    submitButton: {
      backgroundColor: '#1A1919',
      borderRadius: 6,
      textAlign: 'center',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 45,
      paddingRight: 45,
      margin: 20,
    },
    submitButtonText: {
      color: 'white',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

  const storeAuthPartner = async (value: string | null) => {
    if (value === null) {
      try {
        await AsyncStorage.removeItem('@auth_code')
      } catch (error) {
        console.log({error})
      }
    } else {
      try {
        await AsyncStorage.setItem('@auth_code', value!)
      } catch (e) {
        console.log({e})
      }
    }
  }

  const onSubmit = () => {
    const partnerCode = Object.entries(logins)
      .find(login => login[1] === password.trim() && login[0] === username.trim())

    if (partnerCode != null) {
      storeAuthPartner(partnerCode[0])
      login(partnerCode[0])
    }
  }

 return (
    <>
      {
        (Platform.OS == 'ios') &&
        <KeyboardAvoidingView
          behavior={'position'}
        >  
        <View
        style={styles.container}
        onLayout={() => setPortrait(isPortrait())}
      >
        <Image
          style={styles.image}
          resizeMode='contain'
          source={{
            uri: 'https://d2in4d3ntxbclu.cloudfront.net/images/700px/standard/FMBCH-CR-T1-A1-CF-RG-F41.png',
          }}
        />
        <View
          style={styles.form}
        >
          <Text
            style={styles.text}
          >Build A Chair</Text>
          <TextInput 
            onChangeText={setUsername}
            value={username}
            placeholder="Username..."
            style={styles.textInput}
            autoCorrect={false}
            secureTextEntry={false}
            autoCapitalize={'none'}
            textContentType={'username'}
          />
          <TextInput 
            onChangeText={setPassword}
            value={password}
            placeholder="Password..."
            style={styles.textInput}
            autoCorrect={false}
            secureTextEntry={true}
            autoCapitalize={'none'}
            textContentType={'password'}
          />
          <TouchableOpacity 
            style={styles.submitButton}
            onPress={onSubmit}
          >
            <Text style={styles.submitButtonText}>Submit</Text>
          </TouchableOpacity>
        </View>
      </View>
      </KeyboardAvoidingView>
      }
      {
        Platform.OS == 'android' &&
        <KeyboardAvoidingView
          behavior={'position'}
        > 
        <View
        style={styles.container}
        onLayout={() => setPortrait(isPortrait())}
      >
        <Image
          style={{height: 250, width: 200}}
          resizeMode='contain'
          source={{
            uri: 'https://d2in4d3ntxbclu.cloudfront.net/images/700px/standard/FMBCH-CR-T1-A1-CF-RG-F41.png',
          }}
        />
        <View
          style={styles.form}
        >
          <Text
            style={styles.text}
          >Build A Chair</Text>
          <TextInput 
            onChangeText={setUsername}
            value={username}
            placeholder="Username..."
            style={styles.textInput}
            autoCorrect={false}
            secureTextEntry={false}
            autoCapitalize={'none'}
            textContentType={'username'}
          />
          <TextInput 
            onChangeText={setPassword}
            value={password}
            placeholder="Password..."
            style={styles.textInput}
            autoCorrect={false}
            secureTextEntry={true}
            autoCapitalize={'none'}
            textContentType={'password'}
            onSubmit={onSubmit}
          />
          <TouchableOpacity 
            style={styles.submitButton}
            onPress={onSubmit}
          >
            <Text style={styles.submitButtonText}>Submit</Text>
          </TouchableOpacity>
        </View>
      </View>
      </KeyboardAvoidingView>
      }
      
    </>
  )
}

Login.defaultProps = {
  login: PropTypes.func.isRequired,
}